import React from 'react'
import Layout from '../layout/Layout'
import BannerScreen from './Banner/BannerScreen'
import OurServices from './OurServices/OurServices'


const Home = () => {
  return (
    <>
<Layout >
<BannerScreen/>
<OurServices/>
</Layout>
   
   
    </>
  )
}

export default Home